<template>
	<div class="sufferer-merge-page">
		<div class="title">患者管理_合并患者</div>
		<div class="desc">发现疑似相同患者，请判断是否为同一个，若是，选择信息后点击“确认合并”</div>
		<div class="sufferers-table">
			<a-table
        class="hospital-table"
        :pagination="false"
        :dataSource="toMergeData"
        :rowSelection="rowSelection"
        :columns="columns"
        :rowKey="record => record.id"
        :locale="{emptyText:'暂无数据'}"
        size="middle"
			>
				<template slot-scope="text,record" slot="address">
          <span v-if='record.province'>
            <span v-if='record.city'>
              <span v-if='record.country'>{{record.provinceName + '/'+record.cityName +'/'+ record.countryName}}</span>
              <span v-else>{{record.provinceName + '/' +record.cityName}}</span>
            </span>
            <span v-else>{{record.provinceName}}</span>
          </span>
					<span v-else>-</span>
				</template>
			</a-table>
		</div>
		<div style="margin-top:40px;" class="title">合并为</div>
		<div class="sufferers-table">
			<a-table
        class="hospital-table"
        :pagination="false"
        :dataSource="mergeData"
        :locale="{emptyText:'暂无数据'}"
        :rowKey="record => record.id"
        size="middle"
			>
				<a-table-column width="7%">
					<span class="table-th" slot="title">患者姓名</span>
					<template slot-scope="text, record">
						{{record.patientName?record.patientName:'-'}}
					</template>
				</a-table-column>
				<a-table-column width="4%">
					<span class="table-th" slot="title">性别</span>
					<template slot-scope="text, record">
						{{record.sexName?record.sexName:'-'}}
					</template>
				</a-table-column>
				<a-table-column width="7%">
					<span class="table-th" slot="title">数据库ID</span>
					<template slot-scope="text, record">
						<a-select style="width:80px;"
						          v-model="record.clinicalDbId"
						          placeholder="请选择">
							<a-select-option
                :key="item.key"
                :title="item.value"
                v-for="item in clinicalDbIdItem"
                :value="item.value"
							>{{item.value}}
							</a-select-option>
						</a-select>
					</template>
				</a-table-column>
				<a-table-column>
					<span class="table-th" slot="title">身份证号码</span>
					<template slot-scope="text, record">
						<a-select style="width:130px;"
						          v-model="record.patientCardNo"
						          placeholder="请选择">
							<a-select-option
                :key="item.key"
                :title="item.value"
                v-for="item in patientCardNoItem"
                :value="item.value"
							>{{item.value}}
							</a-select-option>
						</a-select>
					</template>
				</a-table-column>
				<a-table-column width="8%">
					<span class="table-th" slot="title">出生日期</span>
					<template slot-scope="text, record">
						{{record.ageBirthDay?record.ageBirthDay:'-'}}
					</template>
				</a-table-column>
				<a-table-column width="7%">
					<span class="table-th" slot="title">疾病类型</span>
					<template slot-scope="text, record">
						{{record.diseaseType?record.diseaseType:'-'}}
					</template>
				</a-table-column>
				<a-table-column>
					<span class="table-th" slot="title">分组</span>
					<template slot-scope="text, record">
						<a-select style="width:80px;"
						          v-model="record.groupName"
						          placeholder="请选择">
							<a-select-option
                :key="item.key"
                :title="item.value"
                v-for="item in groupNameItem"
                :value="item.key"
							>{{item.value}}
							</a-select-option>
						</a-select>
					</template>
				</a-table-column>
				<a-table-column width="10%">
					<span class="table-th" slot="title">籍贯</span>
					<template slot-scope="text, record">
						<span v-if='record.province'>
							<span v-if='record.city'>
								<span v-if='record.country'>{{record.provinceName + '/'+record.cityName +'/'+ record.countryName}}</span>
								<span v-else>{{record.provinceName + '/' +record.cityName}}</span>
							</span>
							<span v-else>{{record.provinceName}}</span>
						</span>
						<span v-else>-</span>
					</template>
				</a-table-column>
				<a-table-column>
					<span class="table-th" slot="title">父亲姓名</span>
					<template slot-scope="text, record">
						<a-select style="width:90px;" v-model="record.fatherName" placeholder="请选择">
							<a-select-option
                :key="item.key"
                :title="item.value"
                v-for="item in fatherNameItem"
                :value="item.value"
							>{{item.value}}
							</a-select-option>
						</a-select>
					</template>
				</a-table-column>
				<a-table-column>
					<span class="table-th" slot="title">父亲手机号</span>
					<template slot-scope="text, record">
						<a-select style="width:90px;" v-model="record.fatherPhone" placeholder="请选择">
							<a-select-option
                :key="item.key"
                :title="item.value"
                v-for="item in fatherPhoneItem"
                :value="item.value"
							>{{item.value}}
							</a-select-option>
						</a-select>
					</template>
				</a-table-column>
				<a-table-column>
					<span class="table-th" slot="title">母亲姓名</span>
					<template slot-scope="text, record">
						<a-select style="width:90px;" v-model="record.motherName" placeholder="请选择">
							<a-select-option
                :key="item.key"
                :title="item.value"
                v-for="item in motherNameItem"
                :value="item.value"
							>{{item.value}}
							</a-select-option>
						</a-select>
					</template>
				</a-table-column>
				<a-table-column>
					<span class="table-th" slot="title">母亲手机号</span>
					<template slot-scope="text, record">
						<a-select style="width:90px;" v-model="record.motherPhone" placeholder="请选择">
							<a-select-option
                :key="item.key"
                :title="item.value"
                v-for="item in motherPhoneItem"
                :value="item.value"
							>{{item.value}}
							</a-select-option>
						</a-select>
					</template>
				</a-table-column>
			</a-table>
		</div>
		<div class="sufferers-btn">
			<a-button style="width:680px;" @click="submitMerge()" type="primary">确认合并</a-button>
		</div>
	</div>
</template>

<script>
  const columns = [
    {
      title: "序号",
      customRender: (text, record, index) => `${index + 1}`
    },
    {
      title: "患者姓名",
      dataIndex: "patientName",
      customRender: (text, record, index) => {
        if (!record.patientName) {
          return '-'
        } else {
          return record.patientName
        }
      }
    },
    {
      title: "性别",
      dataIndex: "sexName",
      customRender: (text, record, index) => {
        if (!record.sexName) {
          return '-'
        } else {
          return record.sexName
        }
      }
    },
    {
      title: "数据库ID",
      dataIndex: "clinicalDbId",
      customRender: (text, record, index) => {
        if (!record.clinicalDbId) {
          return '-'
        } else {
          return record.clinicalDbId
        }
      }
    },
    {
      title: "身份证号码",
      dataIndex: "patientCardNo",
      customRender: (text, record, index) => {
        if (!record.patientCardNo) {
          return '-'
        } else {
          return record.patientCardNo
        }
      }
    },
    {
      title: "出生日期",
      dataIndex: "ageBirthDay",
      customRender: (text, record, index) => {
        if (!record.ageBirthDay) {
          return '-'
        } else {
          return record.ageBirthDay
        }
      }
    },
    {
      title: "疾病类型",
      dataIndex: "diseaseType",
      customRender: (text, record, index) => {
        if (!record.diseaseType) {
          return '-'
        } else {
          return record.diseaseType
        }
      }
    },
    {
      title: "分组",
      dataIndex: "groupName",
      customRender: (text, record, index) => {
        if (!record.groupName) {
          return '-'
        } else {
          return record.groupName
        }
      }
    },
    {
      title: "籍贯",
      scopedSlots: {customRender: "address"}
    },
    {
      title: "父亲姓名",
      dataIndex: "fatherName",
      customRender: (text, record, index) => {
        if (!record.fatherName) {
          return '-'
        } else {
          return record.fatherName
        }
      }
    },
    {
      title: "父亲手机号",
      dataIndex: "fatherPhone",
      customRender: (text, record, index) => {
        if (!record.fatherPhone) {
          return '-'
        } else {
          return record.fatherPhone
        }
      }
    },
    {
      title: "母亲姓名",
      dataIndex: "motherName",
      customRender: (text, record, index) => {
        if (!record.motherName) {
          return '-'
        } else {
          return record.motherName
        }
      }
    },
    {
      title: "母亲手机号",
      dataIndex: "motherPhone",
      customRender: (text, record, index) => {
        if (!record.motherPhone) {
          return '-'
        } else {
          return record.motherPhone
        }
      }
    }
  ];
  export default {
    data() {
      return {
        toMergeData: [],
        mergeData: [],
        columns: columns,
        selectedRowKeys: [],
        selectArr: [],
        patientCardNoItem: [],
        groupNameItem: [],
        fatherNameItem: [],
        fatherPhoneItem: [],
        motherNameItem: [],
        motherPhoneItem: [],
        clinicalDbIdItem: [],
      };
    },
    computed: {
      rowSelection() {
        const {selectedRowKeys} = this;
        return {
          selectedRowKeys,
          onChange: (selectedRowKeys, selectedRows) => {
            this.selectArr = [];
            this.selectedRowKeys = selectedRowKeys;
            this.selectArr = JSON.parse(JSON.stringify(selectedRows));
            this.filtersMergeTo();
          },
          getCheckboxProps: record => ({
            props: {
              disabled: record.name === "Disabled User", // Column configuration not to be checked
              name: record.name
            }
          })
        };
      }
    },
    props: {
      recordMerge: {type: Object, default: {}}
    },
    mounted() {
      this.getToMergeLst();
    },
    methods: {
      getToMergeLst() {
        this.$get("patient/getCanBeMergePatients/" + this.recordMerge.mergeCode).then(res => {
          this.toMergeData = res.data.data;
        });
      },
      filtersMergeTo() {
        if (this.selectArr.length == 0) {
          this.mergeData = [];
        } else {
          this.mergeData[0] = this.selectArr[0];
          this.patientCardNoItem = this.collectSelectData('patientCardNo');
          this.groupNameItem = this.collectSelectData('groupName');
          this.fatherNameItem = this.collectSelectData('fatherName');
          this.fatherPhoneItem = this.collectSelectData('fatherPhone');
          this.motherNameItem = this.collectSelectData('motherName');
          this.motherPhoneItem = this.collectSelectData('motherPhone');
          this.clinicalDbIdItem = this.collectSelectData('clinicalDbId');
        }

      },
      collectSelectData(name) {
        let resArr = [];
        this.selectArr.forEach((item, index) => {
          let json = {};
          if (name == 'groupName') {
            json = {key: item.patientGroupId, value: item[name]}
          } else {
            json = {key: index, value: item[name]};
          }
          if (item[name]) {
            resArr.push(json);
          }
        });
        return resArr;
      },
      getBeMergedIds() {
        let result = [];
        this.selectArr.forEach((item, index) => {
          result.push(item.id);
        })
        return result;
      },
      submitMerge() {
        if (this.mergeData.length == 0) {
          this.$message.warn('请至少选择一个患者进行合并');
        } else {

          let mergeToData = Object.assign({}, this.mergeData[0]);
          mergeToData.patientGroupId = mergeToData.groupName;
          mergeToData.msgFrom = 0;
          let bodyData = {
            beMergedIDs: this.getBeMergedIds(),
            newPatient: mergeToData
          };
          this.$put("patient/mergePatient", bodyData, {
            headers: {
              "Content-Type": "application/json;charset:utf-8"
            }
          }).then(res => {
            if (res.data.code == 1) {
              this.$message.success("患者合并成功");
              this.$emit("close");
              this.$emit('getData');
            } else {
              this.$message.error(res.data.error)
            }
          });
        }

      }
    },
  };
</script>

<style lang="scss" scoped>
	.sufferer-merge-page {
		width: 100%;
		height: 100%;
		background: #fff;
		padding: 80px 40px 40px 40px;
		position: relative;
		overflow: auto;
		.title {
			font-size: 26px;
			font-family: PingFang SC;
			font-weight: 400;
			color: rgba(51, 51, 51, 1);
		}
		.desc {
			font-size: 12px;
			font-family: PingFang SC;
			font-weight: 400;
			color: rgba(164, 164, 164, 1);
			margin: 20px 0 0 0;
		}
		.sufferers-table {
			margin-top: 20px;
		}
		.sufferers-btn {
			margin: 50px 0;
			text-align: center;
		}
	}
</style>